module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/txt-result@3x-08656eb129eab0ed0c96212febe78b1c.png";